// MX phone display. Handles reach the console as wa_ids — bare digit strings
// like `5215500002222` — and every surface that printed one printed it raw.
//
// WHY IT MATTERS (diagnosis A4): in the prospect's "Vincular contacto" picker a
// person Meta never gave us a name for fell back to their wa_id as the row's
// PRIMARY label, so the list read as a column of 13-digit numbers; a named
// person got the same raw string as a shaded second line. A number nobody can
// read is not an identifier a coordinator can pick with confidence.

/**
 * A wa_id / phone as a Mexican number: `+52 55 5500 0222`.
 *
 * Returns the input UNCHANGED when it is not a recognisable MX phone — an
 * Instagram-scoped id, a foreign number, anything non-numeric. Guessing a
 * grouping for a handle we cannot parse would be worse than showing it plainly.
 */
export function formatMxPhone(raw: string): string {
  const value = raw.trim()
  if (value === '' || !/^\+?\d+$/.test(value)) return value
  const digits = value.replace(/\D/g, '')
  if (!digits.startsWith('52')) return value
  let national = digits.slice(2)
  // WhatsApp wa_ids for Mexico carry a legacy '1' between the country code and
  // the ten dialable digits. It is not part of the number a person would write.
  if (national.length === 11 && national.startsWith('1')) national = national.slice(1)
  if (national.length !== 10) return value
  return `+52 ${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`
}
